import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';

import { catchError, finalize } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

import { AuthService } from '../../services/auth/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const authToken = this.retrieveAuthToken();

    if (this.isExcludedEndpoint(req.url) || !authToken) {
      return next
        .handle(req)
        .pipe(catchError((error) => this.handleAuthError(error)));
    }

    const authReq = this.addAuthHeader(req, authToken);
    return next
      .handle(authReq)
      .pipe(catchError((error) => this.handleAuthError(error)));
  }

  private retrieveAuthToken() {
    const USER_PORTAL = localStorage.getItem('USER_PORTAL');
    const userPortal = USER_PORTAL ? JSON.parse(USER_PORTAL) : null;

    return userPortal?.loginDetails?.access_token || null;
  }

  private isExcludedEndpoint(url: string) {
    const excludedEndpoints = ['/auth/signin'];
    return excludedEndpoints.some((endpoint) => url.includes(endpoint));
  }

  private addAuthHeader(
    req: HttpRequest<any>,
    token: string,
  ): HttpRequest<any> {
    return req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  /** Backend uses 403 + message_key for expired/invalid JWT and missing sessions */
  private static readonly LOGOUT_MESSAGE_KEYS = [
    'Token Session Not Found',
    'Invalid Or Expired Token',
  ] as const;

  private handleAuthError(error: any): Observable<never> {
    if (
      error instanceof HttpErrorResponse &&
      error.status === 403 &&
      AuthInterceptor.LOGOUT_MESSAGE_KEYS.includes(error.error?.message_key)
    ) {
      this.authService.postLogout();
    }
    return throwError(() => error);
  }
}
